import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RedoFill = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 12 12"
    >
      <path
        d="M11.0772 5.43273L6.64795 2.14903C6.5537 2.07873 6.4265 2.06748 6.3213 2.12093C6.21585 2.17393 6.1494 2.28183 6.1494 2.39998V4.26423C4.2319 4.30038 2.8552 4.75908 1.9475 5.66243C1.0996 6.50643 0.6875 7.72908 0.6875 9.39998C0.6875 9.54498 0.78735 9.67098 0.92845 9.70418C0.9524 9.71003 0.9763 9.71248 1 9.71248C1.11645 9.71248 1.22605 9.64703 1.2798 9.53913C2.21365 7.66268 4.011 7.57623 6.14945 7.57233V9.39998C6.14945 9.51813 6.21585 9.62603 6.32135 9.67928C6.4268 9.73153 6.55375 9.72128 6.648 9.65098L11.0772 6.36778C11.2266 6.25693 11.3125 6.08653 11.3125 5.90003C11.3125 5.71373 11.2266 5.54333 11.0772 5.43273Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

RedoFill.displayName = 'RedoFill';
